import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolderOpen, faExclamationTriangle, faCheckDouble, faSave, faEdit } from '@fortawesome/free-solid-svg-icons'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAuthServices } from '../../services/useFetch';

export const RegistroClientes = ({ clienteEditar, executeMenu }) => {

    const { requestPost } = useAuthServices();

    const [modalInfo, setModalInfo] = useState(false)
    const [modalError, setModalError] = useState(false)
    const [modalResumen, setModalResumen] = useState(false)

    const modoEdicion = !!clienteEditar;

    const tiposDocumentos = [
        { value: 'C.C', label: 'Cédula de ciudadania' },
        { value: 'C.E', label: 'Cédula de extranjeria' },
        { value: 'PASS', label: 'Pasaporte' },
        { value: 'NIT', label: 'NIT' }
    ]

    const [formStateValue, setformStateValue] = useState({
        tipoDocumento: 'INITIAL',
        numeroDocumento: '',
        nombres: '',
        apellidos: '',
        direccion: '',
        correo: '',
        correo2: '',
        telefono1: '',
        telefono2: '',
    })

    const [formState, setformState] = useState({
        tipoDocumentoRef: false,
        numeroDocumentoRef: false,
        nombresRef: false,
        apellidosRef: false,
        direccionRef: false,
        correoRef: false,
        correo2Ref: false,
        telefono1Ref: false,
        telefono2Ref: false,
    })

    const { tipoDocumento, numeroDocumento, nombres, apellidos, direccion, correo, correo2, telefono1, telefono2 } = formStateValue;
    const { tipoDocumentoRef, numeroDocumentoRef, nombresRef, apellidosRef, direccionRef, correoRef, correo2Ref, telefono1Ref, telefono2Ref } = formState;

    useEffect(() => {
        if (clienteEditar) {
            setformStateValue({
                tipoDocumento: clienteEditar.tipoDocumento || 'INITIAL',
                numeroDocumento: clienteEditar.numeroIdentificacion || '',
                nombres: clienteEditar.nombres || '',
                apellidos: clienteEditar.apellidos || '',
                direccion: clienteEditar.direccion || '',
                correo: clienteEditar.correo1 || '',
                correo2: clienteEditar.correo2 || '',
                telefono1: clienteEditar.telefono1 || '',
                telefono2: clienteEditar.telefono2 || '',
            });
        } else {
            resetForm();
        }
    }, [clienteEditar]);

    const changeInput = (e) => {
        setformStateValue({
            ...formStateValue,
            [e.target.name]: e.target.value
        })
    }

    const changeInputTipoDocumento = (e) => {
        setformStateValue({
            ...formStateValue,
            tipoDocumento: e.target.value
        })
    }

    const registraClienteAction = () => {
        let formValidado = [];
        setformState({
            tipoDocumentoRef: false,
            numeroDocumentoRef: false,
            nombresRef: false,
            apellidosRef: false,
            direccionRef: false,
            correoRef: false,
            correo2Ref: false,
            telefono1Ref: false,
            telefono2Ref: false,
        })

        if (tipoDocumento === 'INITIAL') {
            formValidado.push('tipoDocumentoRef');
        }

        if (!numeroDocumento && numeroDocumento.length === 0) {
            formValidado.push('numeroDocumentoRef');
        }

        if (!nombres && nombres.length === 0) {
            formValidado.push('nombresRef');
        }

        if (!apellidos && apellidos.length === 0) {
            formValidado.push('apellidosRef');
        }

        if (!correo && correo.length === 0) {
            formValidado.push('correoRef');
        }

        if (!telefono1 && telefono1.length === 0) {
            formValidado.push('telefono1Ref');
        }

        if (formValidado.length === 0) {
            handleShow()
        } else {
            setformState({
                tipoDocumentoRef: formValidado.includes('tipoDocumentoRef'),
                numeroDocumentoRef: formValidado.includes('numeroDocumentoRef'),
                nombresRef: formValidado.includes('nombresRef'),
                apellidosRef: formValidado.includes('apellidosRef'),
                direccionRef: formValidado.includes('direccionRef'),
                correoRef: formValidado.includes('correoRef'),
                telefono1Ref: formValidado.includes('telefono1Ref'),
                telefono2Ref: formValidado.includes('telefono2Ref'),
            })
            formValidado.splice(0, formValidado.length)
        }
    }

    const registraClienteService = async () => {
        handleClose()
        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        let idCompany = 0;
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage)
            idCompany = usuarioLocalStorageObj.idCompany;
        }
        const body = {
            idCliente: modoEdicion ? clienteEditar.id : 0,
            tipoDocumento: tipoDocumento,
            numeroDocumento: numeroDocumento,
            nombres: nombres,
            apellidos: apellidos,
            direccion: direccion,
            correo: correo,
            correo2: correo2,
            telefono1: telefono1,
            telefono2: telefono2,
            idCompany: idCompany
        }
        const response = await requestPost(body, 2);
        if (!response.error) {
            const { estado } = response.data
            if (estado) {
                resetForm();
                handleShowInfo()
            }
        } else {
            setModalError(true)
        }
    };

    const resetForm = () => {
        setformStateValue({
            tipoDocumento: 'INITIAL',
            numeroDocumento: '',
            nombres: '',
            apellidos: '',
            direccion: '',
            correo: '',
            telefono1: '',
            telefono2: '',
        })
    };

    const handleShowInfo = () => {
        setModalInfo(true)
    };

    const handleCloseInfo = () => {
        executeMenu({
            target: {
                name: 'buttom1'
            }
        });
        setModalInfo(false)
    };

    const handleCloseError = () => {
        setModalError(false)
    };

    const handleShow = () => {
        setModalResumen(true)
    };

    const handleClose = () => {
        setModalResumen(false)
    };

    return (
        <>
            <h4>{modoEdicion ? 'Editar cliente' : 'Registrar un cliente'}</h4>
            <p className='p-parrafo'>{modoEdicion ? `Estás editando la información de ${clienteEditar.nombres} ${clienteEditar.apellidos}.` : 'Acá podrás agregar tus usuarios, los cuales se dispondrán a los procesos de agendamiento.'}</p>
            <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Tipo documento: </p>
                        <select value={tipoDocumento} onChange={changeInputTipoDocumento} className={tipoDocumentoRef ? 'form-control form-control-error' : 'form-control'} >
                            <option value='INITIAL'>Seleccione</option>
                            {
                                tiposDocumentos.map((key, i) => {
                                    return (
                                        <option key={i} value={key.value}>{key.label}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Número de documento: </p>
                        <input type="text" name='numeroDocumento' className={numeroDocumentoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={numeroDocumento} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Nombres: </p>
                        <input type="text" name='nombres' className={nombresRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={nombres} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Apellidos: </p>
                        <input type="text" name='apellidos' className={apellidosRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={apellidos} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Dirección: </p>
                        <input type="text" name='direccion' className={direccionRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={direccion} onChange={changeInput}
                        />
                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Correo Principal: </p>
                        <input type="text" name='correo' className={correoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={correo} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Correo 2: </p>
                        <input type="text" name='correo2' className={correo2Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={correo2} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Telefono 1: </p>
                        <input type="text" name='telefono1' className={telefono1Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={telefono1} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 " >
                    <div className='div-form'>
                        <p className='p-label-form'> Telefono 2: </p>
                        <input type="text" name='telefono2' className={telefono2Ref ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
                            value={telefono2} onChange={changeInput}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 div-buton-registra-cliente" >

                    <button onClick={registraClienteAction} className='bottom-custom-secondary'>
                        <FontAwesomeIcon icon={modoEdicion ? faEdit : faSave} /> {modoEdicion ? 'Actualizar' : 'Agregar'}
                    </button>

                </div>
            </div>
            <Modal isOpen={modalResumen} onHide={handleClose} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4><FontAwesomeIcon icon={faFolderOpen} className='icon-check' />  Resumen del registro: </h4>
                </ModalHeader>
                <ModalBody>
                    <div className='div-info-item'>
                        <p className='p-label-form-text m-1'>Cliente:</p>
                        <p className='p-label-form m-1'>{tipoDocumento} {nombres} {apellidos}</p>
                    </div>
                    <div className='div-info-item'>
                        <p className='p-label-form-text m-1'>Dirección:</p>
                        <p className='p-label-form m-1'>{direccion}</p>
                    </div>
                    <div className='div-info-item'>
                        <p className='p-label-form-text m-1'>Correo principal:</p>
                        <p className='p-label-form m-1'>{correo}</p>
                    </div>
                    <div className='div-info-item'>
                        <p className='p-label-form-text m-1'>Correo secundario:</p>
                        <p className='p-label-form m-1'>{correo2}</p>
                    </div>
                    <div className='div-info-item'>
                        <p className='p-label-form-text m-1'>Telefono de contacto 1:</p>
                        <p className='p-label-form m-1'>{telefono1}</p>
                    </div>
                    <div className='div-info-item'>
                        <p className='p-label-form-text m-1'>Telefono de contacto 2:</p>
                        <p className='p-label-form m-1'>{telefono2}</p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={handleClose}>
                        Volver
                    </Button>
                    <Button variant="primary" onClick={registraClienteService}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalInfo} onHide={handleCloseInfo} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>{modoEdicion ? 'Cliente actualizado exitosamente' : 'Cliente creado exitosamente'} <FontAwesomeIcon icon={faCheckDouble} className='icon-check' /></h4>
                </ModalHeader>
                <ModalBody>
                    <p>{modoEdicion ? 'La información del cliente ha sido actualizada satisfactoriamente.' : 'El cliente ha sido registrado satisfactoriamente en el sistema.'}</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseInfo}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseError}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
